<template>
  <div class="ItemInfoList">
    <van-nav-bar
      left-arrow
      fixed
      @click-left="goback"
      :title="$t('platform.itemInfo')"
    >
    </van-nav-bar>
    <!-- 物品信息表 -->
    <div v-if="goodsList.length > 0" v-cloak>
      <van-cell-group>
        <van-cell>
          <van-row>
            <van-col span="6">{{ $t("itemInfo.name") }}</van-col>
            <van-col span="6">{{ $t("itemInfo.number") }}</van-col>
            <van-col span="12">{{ $t("itemInfo.operation") }}</van-col>
          </van-row>
          <div slot="right-icon" style="width: 22px"></div>
        </van-cell>
        <van-cell center v-for="item in goodsList" :key="item.id">
          <van-row>
            <van-col span="6">{{ item.name }}</van-col>
            <van-col span="5"
              >{{ item.inventory
              }}{{ item.unit ? item.unit.name : "" }}</van-col
            >
            <van-col span="13">
              <van-button
                round
                type="danger"
                style="width: 85px;height:35px;margin-bottom:5px;"
                @click.stop="bindStock(0, item.id, item.inventory)"
                >{{ $t("itemInfo.exWarehouse") }}</van-button
              >
              <van-button
                round
                type="primary"
                style="width: 85px;height:35px;margin-bottom:5px;"
                @click.stop="bindStock(1, item.id)"
                >{{ $t("itemInfo.warehousing") }}</van-button
              >
              <van-button
                round
                type="info"
                style="width: 85px;height:35px;margin-bottom:5px;"
                @click.stop="bindSee(item.id, item.name)"
                >{{ $t("itemInfo.find") }}</van-button
              >
            </van-col>
          </van-row>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      goodsList: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goback() {
      this.$router.go(-1); //返回上一层
    },
    getList() {
      // 獲取物品信息表
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/menu/list`,
        data: {
          store_id: sessionStorage.actShopId
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res.data.data, "獲取所有物品");
            this.goodsList = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {});
    },
    // 入庫/出庫
    bindStock(type, id, num) {
      this.$router.push({
        path: "/UnitManage",
        query: { id: id, status: type, inventory: num }
      });
    },
    // 查看
    bindSee(id, name) {
      console.log(id, "点击查看详情");
      this.$router.push({ path: "/ItemDetails", query: { id, name } });
    }
    // 修改庫存
    // editInfo(id) {
    //   this.$router.push({ path: "/ItemInfoAdd", query: { id: id } });
    // },
  }
};
</script>

<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-cell-group--inset {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/Platform/ItemInfoList.vue